import React, { useContext } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import * as AuthAPI from '../services/authAPI'
import AuthContext from '../context/AuthContext'

const ROLE_LABELS = {
    ROLE_SUPER_ADMIN: "Super Administrateur",
    ROLE_MANAGER: "Manager",
    ROLE_EMPLOYEE: "Employé"
}

export default function SideBar({ firstName, lastName, role, hasPermission, canAccessBilling, canAccessHelp, isSuperAdmin }) {

    const { setIsAuthenticated } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        AuthAPI.logout();
        setIsAuthenticated(false);
        navigate("/login", { replace: true });
    }

    const isActive = (path) => {
        if (path === '/') return location.pathname === '/';
        if (path === '/routes') return location.pathname === '/routes' || (location.pathname.startsWith('/routes/') && !location.pathname.startsWith('/routes/planning'));
        return location.pathname.startsWith(path);
    };

    return (
        <nav id="sidebar" className="sidebar d-flex flex-column flex-shrink-0 bg-white shadow-3">
            {/* Logo / Brand */}
            <div className="sidebar-header d-flex align-items-center justify-content-center py-4 px-3 border-bottom">
                <Link to={isSuperAdmin ? "/admin" : "/"} className="text-decoration-none">
                    <span className="fw-bold text-primary fs-5">Nemo</span>
                </Link>
            </div>

            {/* User info */}
            <div className="d-flex align-items-center px-3 py-3 border-bottom">
                <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-3"
                     style={{ width: '40px', height: '40px', minWidth: '40px' }}>
                    <span className="text-white fw-bold" style={{ fontSize: '14px' }}>
                        {firstName?.charAt(0)}{lastName?.charAt(0)}
                    </span>
                </div>
                <div className="overflow-hidden">
                    <p className="mb-0 fw-bold text-truncate" style={{ fontSize: '14px' }}>{firstName} {lastName}</p>
                    <small className="text-muted">{ROLE_LABELS[role]}</small>
                </div>
            </div>

            {/* Navigation links */}
            <ul className="nav flex-column px-2 pt-3 flex-grow-1">
                {isSuperAdmin ? (
                    <li className="nav-item mb-1">
                        <Link className={`nav-link sidebar-link rounded-3 d-flex align-items-center ${isActive('/admin') ? 'active bg-primary text-white' : 'text-dark'}`} to="/admin">
                            <i className="fas fa-gears me-3" style={{ width: '20px', textAlign: 'center' }}></i>
                            <span>Administration</span>
                        </Link>
                    </li>
                ) : (
                    <>
                        {hasPermission('logistics') && <li className="nav-item mb-1">
                            <Link className={`nav-link sidebar-link rounded-3 d-flex align-items-center ${isActive('/logistic') ? 'active bg-primary text-white' : 'text-dark'}`} to="/logistic">
                                <i className="fas fa-warehouse me-3" style={{ width: '20px', textAlign: 'center' }}></i>
                                <span>Logistique</span>
                            </Link>
                        </li>}
                        {hasPermission('routes') && <>
                            <li className="nav-item mb-1">
                                <Link className={`nav-link sidebar-link rounded-3 d-flex align-items-center ${isActive('/routes') ? 'active bg-primary text-white' : 'text-dark'}`} to="/routes">
                                    <i className="fas fa-map-location me-3" style={{ width: '20px', textAlign: 'center' }}></i>
                                    <span>Routes</span>
                                </Link>
                            </li>
                            <li className="nav-item mb-1">
                                <Link className={`nav-link sidebar-link rounded-3 d-flex align-items-center ${isActive('/routes/planning') ? 'active bg-primary text-white' : 'text-dark'}`} to="/routes/planning">
                                    <i className="fas fa-calendar me-3" style={{ width: '20px', textAlign: 'center' }}></i>
                                    <span>Planification des routes</span>
                                </Link>
                            </li>
                        </>}
                        {canAccessBilling && <li className="nav-item mb-1">
                            <Link className={`nav-link sidebar-link rounded-3 d-flex align-items-center ${isActive('/billing') ? 'active bg-primary text-white' : 'text-dark'}`} to="/billing">
                                <i className="fas fa-file-invoice me-3" style={{ width: '20px', textAlign: 'center' }}></i>
                                <span>Facturation</span>
                            </Link>
                        </li>}
                        {hasPermission('users:manager') && <li className="nav-item mb-1">
                            <Link className={`nav-link sidebar-link rounded-3 d-flex align-items-center ${isActive('/users') ? 'active bg-primary text-white' : 'text-dark'}`} to="/users">
                                <i className="fas fa-users me-3" style={{ width: '20px', textAlign: 'center' }}></i>
                                <span>Utilisateurs</span>
                            </Link>
                        </li>}
                    </>
                )}
            </ul>

            {/* Bottom section */}
            <div className="border-top px-2 py-3">
                {!isSuperAdmin && canAccessHelp && (
                    <Link className={`nav-link sidebar-link rounded-3 d-flex align-items-center ${isActive('/help') ? 'active bg-primary text-white' : 'text-dark'}`} to="/help">
                        <i className="fas fa-question-circle me-3" style={{ width: '20px', textAlign: 'center' }}></i>
                        <span>Aide</span>
                    </Link>
                )}
                <button onClick={handleLogout} className="nav-link sidebar-link rounded-3 d-flex align-items-center text-danger w-100 border-0 bg-transparent">
                    <i className="fas fa-sign-out-alt me-3" style={{ width: '20px', textAlign: 'center' }}></i>
                    <span>Deconnexion</span>
                </button>
            </div>
        </nav>
    )
}
